import { retrieveContentfulImage } from "../common/image";

export const getPartnerOfferingsData = (componentData) => {
    const data = {};
    data.title = componentData?.fields?.title;
    data.subtitle = componentData?.fields?.subtitle;

    data.offerings = componentData?.fields?.elements?.map(i => {
        const elementFields = i?.fields;
        if(elementFields) {
            return {
                id: i?.sys?.id,
                name: elementFields.name,
                image: {
                    url: elementFields.image?.fields?.file?.url && retrieveContentfulImage(elementFields.image.fields.file.url, {
                        width: 720,
                        height: 400,
                        fit: "fill"
                    }),
                    alt: elementFields.image?.fields?.title
                },
                countries: elementFields.countries,
                tags: elementFields.tags?.map(i => i.fields.title),
                description: elementFields.description,
                mainPerk: elementFields.mainPerk,
                subperksTitle: elementFields.subperksTitle,
                subperks: elementFields.subperks,
                promoCode: elementFields.promoCode,
                promoUrl: elementFields.promoURL,
                bookingInformation: elementFields.bookingInformation,
            };
        }
    });

    return data;
};
